import { IMenuLayoult } from ".";
import Common from "../../services/common";

export interface IFavoritos {
  iduser: number;
  favoritos: string[];
}

export interface IHistorico {
  iduser: number;
  historial: string[];
}


export const searchPath = (url:string, menus: IMenuLayoult[]) : IMenuLayoult[] => {

  for(var i = 0; i< menus.length; i++) {
    const menu = menus[i];

    if (url.startsWith(menu.url ?? '@')) {
      if (!menu.menus || menu.menus.length < 1) return [menu];
      return [...[menu], ...searchPath(url, menu.menus)]
    }
  }

  return [];
}


export const getHistorial = (iduser?:number) => {
  return (((Common.session.get("CNET-BO-MenuHistorial") ?? []) as IHistorico[]).find(p => p.iduser === iduser)?.historial ?? []);
}

export function AddHistorial(url?: string, iduser?:number) {
  const historiales = (Common.session.get("CNET-BO-MenuHistorial") ?? []) as IHistorico[];
  let historial = historiales.find(p => p.iduser === iduser);
  
  if (!historial) {
    historiales.push({
      iduser: iduser!,
      historial: [ url! ]
    })
    Common.session.set("CNET-BO-MenuHistorial", historiales);
    return;
  }

  if (!!historial?.historial.includes(url!))
    historial.historial = historial.historial.filter(p => p !== url);
  historial.historial.unshift(url!);
  historial.historial = historial.historial.slice(0,5);

  Common.session.set("CNET-BO-MenuHistorial", historiales);
}

export const getFavoritos = (iduser?:number) => {
  return ((Common.session.get("CNET-BO-MenuFavoritos") ?? []) as IFavoritos[]).find(p => p.iduser === iduser)?.favoritos ?? [];
}

export const swithFavorito = (iduser?: number, url?: string) => {
  const favoritos = (Common.session.get("CNET-BO-MenuFavoritos") ?? []) as IFavoritos[];
  let favorito = favoritos.find(p => p.iduser === iduser);

  if (!favorito) {
    favoritos.push({
      iduser: iduser!,
      favoritos: [ url! ]
    })
    Common.session.set("CNET-BO-MenuFavoritos", favoritos);
    return;
  }

  if (!!favorito?.favoritos.includes(url!))
    favorito.favoritos = favorito.favoritos.filter(p => p !== url);
  else
    favorito.favoritos.push(url!);
  
  Common.session.set("CNET-BO-MenuFavoritos", favoritos);
}